// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e89952c","239":"a381efd6","488":"e6585ac8","732":"007b5cfd","952":"740e7c60"}[chunkId] + ".chunk.js";
};